module.exports = __webpack_public_path__ + "static/media/jsLogo.413090fa.png";